import axiosInstance from '../../utils/axiosConfig';

export const GET_USER_REQUEST = 'GET_USER_REQUEST';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAILURE = 'GET_USER_FAILURE';

// ----------------------------------------------------------------------

export const FILTER_USERS_BY_GROUP_LABEL_REQUEST = 'FILTER_USERS_BY_GROUP_LABEL_REQUEST';
export const FILTER_USERS_BY_GROUP_LABEL_SUCCESS = 'FILTER_USERS_BY_GROUP_LABEL_SUCCESS';
export const FILTER_USERS_BY_GROUP_LABEL_FAILURE = 'FILTER_USERS_BY_GROUP_LABEL_FAILURE';

// ----------------------------------------------------------------------

export const getUserRequest = () => ({
    type: GET_USER_REQUEST
});

export const getUserSuccess = (user) => ({
    type: GET_USER_SUCCESS,
    payload: user
});

export const getUserFailure = (error) => ({
    type: GET_USER_FAILURE,
    payload: error
});

// ----------------------------------------------------------------------

export const filterUsersByGroupLabelRequest = () => ({
    type: FILTER_USERS_BY_GROUP_LABEL_REQUEST
});

export const filterUsersByGroupLabelSuccess = (users) => ({
    type: FILTER_USERS_BY_GROUP_LABEL_SUCCESS,
    payload: users
});

export const filterUsersByGroupLabelFailure = (error) => ({
    type: FILTER_USERS_BY_GROUP_LABEL_FAILURE,
    payload: error
});
// ----------------------------------------------------------------------


export const fetchUser = () => {
    return async (dispatch) => {
        const userId = localStorage.getItem('userId');
        const token = localStorage.getItem('token');
        if (!userId || !token) {
            return dispatch(getUserFailure('User ID or token is missing'));
        }

       await dispatch(getUserRequest());
        try {
            const response = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL_MS_USER}/getUser/${userId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const user = response.data.user;
          await  dispatch(getUserSuccess(user));
            return user
        } catch (error) {
            dispatch(getUserFailure(error.message));
        }
    };
};

export const filterUsersByGroupLabel = (groupLabel) => {
    return async (dispatch) => {
        const token = localStorage.getItem('token');
        if (!token) {
            return  await dispatch(filterUsersByGroupLabelFailure('Token is missing'));
        }

         filterUsersByGroupLabelRequest();
        try {
            const response = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL_MS_USER}/filterUsersByGroupLabel`,
                { groupLabel },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
            const users = response.data.users;
            filterUsersByGroupLabelSuccess(users);
            return users
        } catch (error) {
            filterUsersByGroupLabelFailure(error.message);
        }
    };
};

export const getUserById = async (userId) => {
    const token = localStorage.getItem('token');
    if (!token) {
        throw new Error('Token is missing');
    }

    try {
        const response = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL_MS_USER}/getUser/${userId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data.user;
    } catch (error) {
        throw new Error(error.message);
    }
};

export const getUserGroups = () => {
    return async (dispatch) => {
        const token = localStorage.getItem('token');
        if (!token) {
            return dispatch({
                type: 'GET_USER_GROUPS_FAILURE',
                payload: 'Token is missing'
            });
        }

        dispatch({
            type: 'GET_USER_GROUPS_REQUEST'
        });

        try {
            const response = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL_MS_USER}/getAllUserGroup`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const groups = response.data.userGroups;
            dispatch({
                type: 'GET_USER_GROUPS_SUCCESS',
                payload: groups
            });
            return groups;
        } catch (error) {
            dispatch({
                type: 'GET_USER_GROUPS_FAILURE',
                payload: error.message
            });
        }
    };
};
export const getAllAuthorities = () => {
    return async (dispatch) => {
        const token = localStorage.getItem('token');
        if (!token) {
            return dispatch({
                type: 'GET_ALL_AUTHORITIES_FAILURE',
                payload: 'Token is missing'
            });
        }

        dispatch({
            type: 'GET_ALL_AUTHORITIES_REQUEST'
        });

        try {
            const response = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL_MS_USER}/getAllAuthority`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const authorities = response.data;
            dispatch({
                type: 'GET_ALL_AUTHORITIES_SUCCESS',
                payload: authorities
            });
            return authorities;
        } catch (error) {
            dispatch({
                type: 'GET_ALL_AUTHORITIES_FAILURE',
                payload: error.message
            });
        }
    };
};
 
export const createUserGroup = async (groupData) => {
    const token = localStorage.getItem('token');
    if (!token) {
        throw new Error('Token is missing');
    }

    try {
        const response = await axiosInstance.post(
            `${process.env.REACT_APP_BACKEND_URL_MS_USER}/createUserGroup`, 
            groupData, 
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }
        );
        return response.data.newUserGroup;
    } catch (error) {
        // Conserver error.response : l'appelant affiche le message serveur (doublon de libellé/uid)
        throw error;
    }
};

export const updateUserGroup = (groupId, groupData) => {
    return async (dispatch) => {
        const token = localStorage.getItem('token');
        if (!token) {
            return dispatch({
                type: 'UPDATE_USER_GROUP_FAILURE',
                payload: 'Token is missing'
            });
        }

        dispatch({ type: 'UPDATE_USER_GROUP_REQUEST' });

        try {
            const response = await axiosInstance.put(`${process.env.REACT_APP_BACKEND_URL_MS_USER}/updateUserGroup/${groupId}`, groupData, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const updatedGroup = response.data;
            dispatch({
                type: 'UPDATE_USER_GROUP_SUCCESS',
                payload: updatedGroup
            });
            return updatedGroup;
        } catch (error) {
            dispatch({
                type: 'UPDATE_USER_GROUP_FAILURE',
                payload: error.message
            });
        }
    };
};

export const deleteUserGroup = (groupId) => {
    return async (dispatch) => {
        const token = localStorage.getItem('token');
        if (!token) {
            return dispatch({
                type: 'DELETE_USER_GROUP_FAILURE',
                payload: 'Token is missing'
            });
        }

        dispatch({ type: 'DELETE_USER_GROUP_REQUEST' });

        try {
            await axiosInstance.delete(`${process.env.REACT_APP_BACKEND_URL_MS_USER}/deleteUserGroup/${groupId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            dispatch({
                type: 'DELETE_USER_GROUP_SUCCESS',
                payload: groupId
            });
            return true;
        } catch (error) {
            dispatch({
                type: 'DELETE_USER_GROUP_FAILURE',
                payload: error.message
            });
        }
    };
};

export const createDAAQ = (daaqData) => {
    return async (dispatch) => {
        const token = localStorage.getItem('token');
        if (!token) {
            return dispatch({
                type: 'CREATE_DAAQ_FAILURE',
                payload: 'Token is missing'
            });
        }

        dispatch({ type: 'CREATE_DAAQ_REQUEST' });

        try {
            const response = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL_MS_USER}/createDAAQ`, daaqData, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const newDAAQ = response.data.newDaaq;
            dispatch({
                type: 'CREATE_DAAQ_SUCCESS',
                payload: newDAAQ
            });
            return newDAAQ;
        } catch (error) {
            dispatch({
                type: 'CREATE_DAAQ_FAILURE',
                payload: error.message
            });
        }
    };
};

export const addDAAQToUserGroup = (groupId, daaqId) => {
    return async (dispatch) => {
        const token = localStorage.getItem('token');

        if (!token) {
            return dispatch({
                type: 'ADD_DAAQ_TO_USER_GROUP_FAILURE',
                payload: 'Token is missing'
            });
        }

        dispatch({ type: 'ADD_DAAQ_TO_USER_GROUP_REQUEST' });

        try {
            const response = await axiosInstance.post(
                `${process.env.REACT_APP_BACKEND_URL_MS_USER}/addDAAQToUserGroup/${groupId}`,
                { uid: daaqId },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            const updatedUserGroup = response.data.userGroup ?? response.data; // une réponse 2xx est un succès même si la clé attendue est absente
            dispatch({
                type: 'ADD_DAAQ_TO_USER_GROUP_SUCCESS',
                payload: updatedUserGroup
            });

            return updatedUserGroup;
        } catch (error) {
            dispatch({
                type: 'ADD_DAAQ_TO_USER_GROUP_FAILURE',
                payload: error.response?.data?.errors || error.message
            });
        }
    };
};
export const addAuthorityToUserGroup = (groupId, authoritiesId) => {
    return async (dispatch) => {
        const token = localStorage.getItem('token');

        if (!token) {
            return dispatch({
                type: 'ADD_AUTHORITY_TO_USER_GROUP_FAILURE',
                payload: 'Token is missing'
            });
        }

        dispatch({ type: 'ADD_AUTHORITY_TO_USER_GROUP_REQUEST' });

        try {
            const response = await axiosInstance.post(
                `${process.env.REACT_APP_BACKEND_URL_MS_USER}/addAuthorityToUserGroup/${groupId}`,
                { uid: authoritiesId },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            const updatedUserGroup = response.data.userGroup ?? response.data; // une réponse 2xx est un succès même si la clé attendue est absente
            dispatch({
                type: 'ADD_AUTHORITY_TO_USER_GROUP_SUCCESS',
                payload: updatedUserGroup
            });

            return updatedUserGroup;
        } catch (error) {
            dispatch({
                type: 'ADD_AUTHORITY_TO_USER_GROUP_FAILURE',
                payload: error.response?.data?.errors || error.message
            });
        }
    };
};

export const getAllUsers = () => {
    return async (dispatch) => {
        const token = localStorage.getItem('token');
        if (!token) {
            return dispatch({
                type: 'GET_ALL_USERS_FAILURE',
                payload: 'Token is missing'
            });
        }

        dispatch({
            type: 'GET_ALL_USERS_REQUEST'
        });

        try {
            const response = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL_MS_USER}/getAllUser`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const users = response.data.user;
            dispatch({
                type: 'GET_ALL_USERS_SUCCESS',
                payload: users
            });
            return users;
        } catch (error) {
            dispatch({
                type: 'GET_ALL_USERS_FAILURE',
                payload: error.message
            });
        }
    };
};
export const deleteDAAQ = (daaqId) => {
    return async (dispatch) => {
        const token = localStorage.getItem('token');
        if (!token) {
            return dispatch({
                type: 'DELETE_DAAQ_FAILURE',
                payload: 'Token is missing'
            });
        }

        dispatch({ type: 'DELETE_DAAQ_REQUEST' });

        try {
            await axiosInstance.delete(`${process.env.REACT_APP_BACKEND_URL_MS_USER}/deleteDAAQ/${daaqId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            dispatch({
                type: 'DELETE_DAAQ_SUCCESS',
                payload: daaqId
            });
        } catch (error) {
            dispatch({
                type: 'DELETE_DAAQ_FAILURE',
                payload: error.message
            });
        }
    };
};

export const removeAuthorityFromUserGroup = (groupId, authoritiesId) => {
    return async (dispatch) => {
        const token = localStorage.getItem('token');

        if (!token) {
            return dispatch({
                type: 'REMOVE_AUTHORITY_FROM_USER_GROUP_FAILURE',
                payload: 'Token is missing'
            });
        }

        dispatch({ type: 'REMOVE_AUTHORITY_FROM_USER_GROUP_REQUEST' });

        try {
            const response = await axiosInstance.post(
                `${process.env.REACT_APP_BACKEND_URL_MS_USER}/removeAuthorityFromUserGroup/${groupId}`,
                { uid: authoritiesId },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            const updatedUserGroup = response.data.userGroup ?? response.data; // une réponse 2xx est un succès même si la clé attendue est absente
            dispatch({
                type: 'REMOVE_AUTHORITY_FROM_USER_GROUP_SUCCESS',
                payload: updatedUserGroup
            });

            return updatedUserGroup;
        } catch (error) {
            dispatch({
                type: 'REMOVE_AUTHORITY_FROM_USER_GROUP_FAILURE',
                payload: error.response?.data?.errors || error.message
            });
        }
    };
};

export const removeDAAQFromUserGroup = (groupId, daaqId) => {
    return async (dispatch) => {
        const token = localStorage.getItem('token');

        if (!token) {
            return dispatch({
                type: 'REMOVE_DAAQ_FROM_USER_GROUP_FAILURE',
                payload: 'Token is missing'
            });
        }

        dispatch({ type: 'REMOVE_DAAQ_FROM_USER_GROUP_REQUEST' });

        try {
            const response = await axiosInstance.post(
                `${process.env.REACT_APP_BACKEND_URL_MS_USER}/removeDAAQFromUserGroup/${groupId}`,
                { uid: daaqId },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            const updatedUserGroup = response.data.userGroup ?? response.data; // une réponse 2xx est un succès même si la clé attendue est absente
            dispatch({
                type: 'REMOVE_DAAQ_FROM_USER_GROUP_SUCCESS',
                payload: updatedUserGroup
            });

            return updatedUserGroup;
        } catch (error) {
            dispatch({
                type: 'REMOVE_DAAQ_FROM_USER_GROUP_FAILURE',
                payload: error.response?.data?.errors || error.message
            });
        }
    };
};

export const getAllDaaqs = () => {
    return async (dispatch) => {
        const token = localStorage.getItem('token');
        if (!token) {
            return dispatch({
                type: 'GET_ALL_DAAQS_FAILURE',
                payload: 'Token is missing'
            });
        }

        dispatch({
            type: 'GET_ALL_DAAQS_REQUEST'
        });

        try {
            const response = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL_MS_USER}/getAllDAAQs`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const daaqs = response.data;
            dispatch({
                type: 'GET_ALL_DAAQS_SUCCESS',
                payload: daaqs
            });
            return daaqs;
        } catch (error) {
            dispatch({
                type: 'GET_ALL_DAAQS_FAILURE',
                payload: error.message
            });
        }
    };
};


export const createUser = (userData) => {
    return async (dispatch) => {
        const token = localStorage.getItem('token');
        if (!token) {
            return dispatch({
                type: 'CREATE_USER_FAILURE',
                payload: 'Token is missing'
            });
        }

        dispatch({ type: 'CREATE_USER_REQUEST' });

        try {
            const response = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL_MS_USER}/createUser`, userData, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const newUser = response.data.newUser;
            dispatch({
                type: 'CREATE_USER_SUCCESS',
                payload: newUser
            });
            return newUser;
        } catch (error) {
            dispatch({
                type: 'CREATE_USER_FAILURE',
                payload: error.message
            });
        }
    };
};

export const addAuthorityToUser= (userId, authoritiesId) => {
    return async (dispatch) => {
        const token = localStorage.getItem('token');

        if (!token) {
            return dispatch({
                type: 'ADD_AUTHORITY_TO_FAILURE',
                payload: 'Token is missing'
            });
        }

        dispatch({ type: 'ADD_AUTHORITY_TO_USER_REQUEST' });

        try {
            const response = await axiosInstance.post(
                `${process.env.REACT_APP_BACKEND_URL_MS_USER}/addAuthorityToUser/${userId}`,
                { uid: authoritiesId },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            const updatedUser = response.data;
            dispatch({
                type: 'ADD_AUTHORITY_TO_USER_SUCCESS',
                payload: updatedUser
            });

            return updatedUser;
        } catch (error) {
            dispatch({
                type: 'ADD_AUTHORITY_TO_USER_FAILURE',
                payload: error.response?.data?.errors || error.message
            });
        }
    };
};

export const addDAAQToUser = (userId, daaqId) => {
    return async (dispatch) => {
        const token = localStorage.getItem('token');

        if (!token) {
            return dispatch({
                type: 'ADD_DAAQ_TO_USER_FAILURE',
                payload: 'Token is missing'
            });
        }

        dispatch({ type: 'ADD_DAAQ_TO_USER_REQUEST' });

        try {
            const response = await axiosInstance.post(
                `${process.env.REACT_APP_BACKEND_URL_MS_USER}/addDAAQToUser/${userId}`,
                { uid: daaqId },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            const updatedUser = response.data.userGroup ?? response.data; // une réponse 2xx est un succès même si la clé attendue est absente
            dispatch({
                type: 'ADD_DAAQ_TO_USER_SUCCESS',
                payload: updatedUser
            });

            return updatedUser;
        } catch (error) {
            dispatch({
                type: 'ADD_DAAQ_TO_USER_FAILURE',
                payload: error.response?.data?.errors || error.message
            });
        }
    };
}

export const AddUserGroupToUser = (userId, daaqId) => {
    return async (dispatch) => {
        const token = localStorage.getItem('token');

        if (!token) {
            return dispatch({
                type: 'ADD_USER_GROUP_TO_USER_FAILURE',
                payload: 'Token is missing'
            });
        }

        dispatch({ type: 'ADD_USER_GROUP_TO_USER_REQUEST' });

        try {
            const response = await axiosInstance.post(
                `${process.env.REACT_APP_BACKEND_URL_MS_USER}/addUserGroupToUser/${userId}`,
                { uid: daaqId },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            const updatedUser = response.data.user ?? response.data; // une réponse 2xx est un succès même si la clé attendue est absente
            dispatch({
                type: 'ADD_USER_GROUP_TO_USER_SUCCESS',
                payload: updatedUser
            });

            return updatedUser;
        } catch (error) {
            dispatch({
                type: 'ADD_USER_GROUP_TO_USER_FAILURE',
                payload: error.response?.data?.errors || error.message
            });
        }
    };
};
export const checkDaaqExist = (readDaaq) => {
        return async (dispatch) => {
            const token = localStorage.getItem('token');
            if (!token) {
                return dispatch({
                    type: 'CHECK_DAAQ_EXIST_FAILURE',
                    payload: 'Token is missing'
                });
            }
    
            dispatch({ type: 'DELETE_DAAQ_REQUEST' });
    
            try {
                const response  = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL_MS_USER}/checkDAAQExists` ,
                    {"readDAAQ" : readDaaq}, 
                    {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                const daaqs = response.data;
                dispatch({
                    type: 'CHECK_DAAQ_EXIST_SUCCESS',
                    payload: readDaaq
                });
                return daaqs;
            } catch (error) {
                dispatch({
                    type: 'CHECK_DAAQ_EXIST_FAILURE',
                    payload: error.message
                });
            }
        };
};

export const deleteUser = (userId) => {
    return async (dispatch) => {
        const token = localStorage.getItem('token');
        if (!token) {
            return dispatch({
                type: 'DELETE_USER_FAILURE',
                payload: 'Token is missing'
            });
        }

        dispatch({ type: 'DELETE_USER_REQUEST' });

        try {
            await axiosInstance.delete(`${process.env.REACT_APP_BACKEND_URL_MS_USER}/deleteUser/${userId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            dispatch({
                type: 'DELETE_USER_SUCCESS',
                payload: userId
            });
            return true;
        } catch (error) {
            dispatch({
                type: 'DELETE_USER_FAILURE',
                payload: error.message
            });
        }
    };
};

export async function updateUser (id, updateData) {
    try {
      const url = `${process.env.REACT_APP_BACKEND_URL_MS_USER}/updateUser/${id}`;
      const response = await axiosInstance.put(url , updateData );
      return response.data;
    } catch (error) {
      console.error(`Error update User : ${error.message}`);
    }
  };

export async function sendNewPasswordEmail (id) {
    const url = `${process.env.REACT_APP_BACKEND_URL_MS_USER}/sendNewPasswordEmail/${id}`;
    const response = await axiosInstance.post(url);
    return response.data;
  };

export const RemoveUserGroupFromUser = (userId, userGroupUid) => {
    return async (dispatch) => {
        const token = localStorage.getItem('token');

        if (!token) {
            return dispatch({
                type: 'Remove_UserGroup_From_User_FAILURE',
                payload: 'Token is missing'
            });
        }

        dispatch({ type: 'Remove_UserGroup_From_User_REQUEST' });

        try {
            const response = await axiosInstance.post(
                `${process.env.REACT_APP_BACKEND_URL_MS_USER}/removeUserGroupFromUser/${userId}`,
                { uid: userGroupUid },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            const updatedUserGroup = response.data.userGroup ?? response.data; // une réponse 2xx est un succès même si la clé attendue est absente
            dispatch({
                type: 'Remove_UserGroup_From_User_SUCCESS',
                payload: updatedUserGroup
            });

            return updatedUserGroup;
        } catch (error) {
            dispatch({
                type: 'Remove_UserGroup_From_User_FAILURE',
                payload: error.response?.data?.errors || error.message
            });
        }
    };
};

export const RemoveDAAQFromUser = (userId, daaqId) => {
    return async (dispatch) => {
        const token = localStorage.getItem('token');

        if (!token) {
            return dispatch({
                type: 'REMOVE_DAAQ_FROM_USER_FAILURE',
                payload: 'Token is missing'
            });
        }

        dispatch({ type: 'REMOVE_DAAQ_FROM_USER_REQUEST' });

        try {
            const response = await axiosInstance.post(
                `${process.env.REACT_APP_BACKEND_URL_MS_USER}/removeDAAQFromUser/${userId}`,
                { uid: daaqId },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            const updatedUser = response.data.user ?? response.data; // une réponse 2xx est un succès même si la clé attendue est absente
            dispatch({
                type: 'REMOVE_DAAQ_FROM_USER_SUCCESS',
                payload: updatedUser
            });

            return updatedUser;
        } catch (error) {
            dispatch({
                type: 'REMOVE_DAAQ_FROM_USER_FAILURE',
                payload: error.response?.data?.errors || error.message
            });
        }
    };
};

export const RemoveAuthorityFromUser = (userId, authoritiesId) => {
    return async (dispatch) => {
        const token = localStorage.getItem('token');

        if (!token) {
            return dispatch({
                type: 'REMOVE_AUTHORITY_FROM_USER_FAILURE',
                payload: 'Token is missing'
            });
        }

        dispatch({ type: 'REMOVE_AUTHORITY_FROM_USER_REQUEST' });

        try {
            const response = await axiosInstance.post(
                `${process.env.REACT_APP_BACKEND_URL_MS_USER}/removeAuthorityFromUser/${userId}`,
                { uid: authoritiesId },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            const updatedUser = response.data.user ?? response.data; // une réponse 2xx est un succès même si la clé attendue est absente
            dispatch({
                type: 'REMOVE_AUTHORITY_FROM_USER_SUCCESS',
                payload: updatedUser
            });

            return updatedUser;
        } catch (error) {
            dispatch({
                type: 'REMOVE_AUTHORITY_FROM_USER_FAILURE',
                payload: error.response?.data?.errors || error.message
            });
        }
    };
};